import { connect } from "react-redux";
import { withRouter } from "react-router";
import { get } from "lodash";

import MentorshipSessionStepWrapper from "views/Mentorship/MentorshipSessionStepWrapper";

import {
  initQuiz,
  initQuizAnswers,
  initSession,
  startSession,
  stepCompleted,
} from "actions/sessionAction";

import {
  initMentorship,
  setCurrentSessionStepIndex,
  setCurrentStepId,
} from "actions/mentorshipAction";

import { isPreviewSearch } from "common/preview";

const mapStateToProps = (
  {
    session: { currentSession, quizAnswers },
    mentorship: {
      partnerDetails,
      sessions: { ongoingSessions },
      currentMentorshipSessionProgress,
      currentSessionStepIndex,
      currentStepId,
    },
    auth: { user: { role, status } },
  },
  ownProps
) => {
  const firstStepId = get(currentSession, "sessionSteps[0].id");
  const isPreview = isPreviewSearch(get(ownProps, "location.search", ""));

  return {
    session: currentSession,
    quizAnswers,
    role,
    partnerDetails,
    mentorshipId: get(status, "mentorships[0].id"),
    firstStepId,
    currentSessionStepIndex,
    currentMentorshipSessionStatus: currentMentorshipSessionProgress,
    currentStepId,
    isPreview,
  };
};

const isPromise = (val) => val && typeof val.then === "function";
const makeNoopIfPreview = (dispatch, isPreview, actionCreator) => {
  return (...args) => {
    if (isPreview) {
      return Promise.resolve();
    }
    const result = dispatch(actionCreator(...args));
    return isPromise(result) ? result : Promise.resolve(result);
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const isPreview = isPreviewSearch(get(ownProps, "location.search", ""));

  return {
    initSession: (sessionId, isLearningHub) =>
      dispatch(initSession(sessionId, isLearningHub)),
    initQuiz: (quizId, stepId, isLearningHub) =>
      dispatch(initQuiz(quizId, stepId, isLearningHub)),
    initQuizAnswers: (sessionId, stepId, quizId, isLearningHub) =>
      dispatch(initQuizAnswers(sessionId, stepId, quizId, isLearningHub)),

    initMentorship: (id) => dispatch(initMentorship(id)),

    setCurrentSessionStepIndex: (idx) =>
      dispatch(setCurrentSessionStepIndex(idx)),
    setCurrentStepId: (id) => dispatch(setCurrentStepId(id)),

    startSession: makeNoopIfPreview(dispatch, isPreview, startSession),
    stepCompleted: makeNoopIfPreview(dispatch, isPreview, stepCompleted),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MentorshipSessionStepWrapper)
);
